import { Link, useParams } from "react-router-dom";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal, notification } from "antd";
import axiosInstance from "../../../../Services/axiosCommon";
import More from "../../../../Components/Icons/More";
import ViewActivity from "../../../Web/Items/Activity/ViewActivity";
import EditActivity from "../../../Web/Items/Activity/EditActivity";
import { GetAccess } from "../../../../Components/Utils/roles";
import { useState } from "react";

const ViewMore = ({ data, getData,id ,onCancel}) => {
  const { confirm } = Modal;
  const [open, setOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const handleDelete = async(id,removevalue) =>{
    confirm({
        title: `Do you Want to delete ${removevalue}?`,
          centered:true,
        icon: <ExclamationCircleFilled />,
        content: `The ${removevalue} will be removed from the Activity/Item List`,
        okText: 'Yes',
        cancelText: 'No',
        okButtonProps: {
          style: {
            backgroundColor: "#3369ff",
            borderColor: "#3369ff",
            color: "#FFFFFF",
          },
        },
        onOk() {
          axiosInstance.delete(`/Activity/${id}`)
          .then((res) => {
            if (res.status === 201 || res.status === 200) {
              getData();
              api.success({
                message: `Activity has deleted successfully`,
                description: res?.data?.msg || " ",
                placement: "bottomRight",
              });
            } else {
              api.error({
                message: `Activity has delete failed`,
                description: res?.data?.msg || "Network error",
                placement: "bottomRight",
              });
            }
          })
          .catch((error) => {
            console.log(error,"error");
            
            api.error({
              message: `Activity has delete failed`,
              description:
                "Sever error (or) Network error",
              placement: "bottomRight",
            });
          });
      },
      onCancel() {},
    });
  };




  return (
    <>
    {contextHolder}
      <div className='text-[#344767]  relative dropdown inline-block z-50'>
        <div className=' cursor-pointer underline-offset-8 text-xs mx-auto font-semibold flex items-center'>
          <span className=' w-7 h-7 bg-gray-50 flex flex-col items-center justify-center rounded-full'>
            <More/>
          </span>
        </div>
        <ul className='dropdown-menuOne   text-[#344767] text-left  rounded-lg absolute -left-[100px] -top-4 overflow-hidden hidden  z-50 shadow-lg'>

         <li className='w-[100px] bg-black block m-0'>
            <span
              className='bg-white hover:bg-gray-100 cursor-pointer py-2 px-2 block whitespace-no-wrap text-xs font-medium'
              onClick={() => setViewOpen(true)}
            >
              View
            </span>
          </li>
         {GetAccess("activity_item_edit") && <li className=' w-[100px] bg-black block m-0'>
            <span
              className='bg-white hover:bg-gray-100 cursor-pointer py-2 px-2 block whitespace-no-wrap text-xs font-medium'
              onClick={() => setOpen(true)}
            >
              Edit
            </span>
          </li>}
          {/* {
            ProjectDelete && */}
          {
            GetAccess("activity_item_delete") && (
              <li className=' w-[100px] bg-black block m-0'>
              <span
                className='bg-white hover:bg-gray-100 cursor-pointer py-2 px-2 block whitespace-no-wrap text-xs font-medium'
                onClick={
                  () => {
                    handleDelete(data.id,data?.item_code);
                  }
                }
              >
                Delete
              </span>
            </li>
            )
          }
          {/* } */}
        </ul>
      </div>
      <EditActivity
            data={data}
open={open} onCancel={() => { setOpen(false) }} getData={getData}
firstProject={id}
      />
      <Modal
        open={viewOpen}
        onCancel={()=>setViewOpen(false)}
        title={"View Activity"}
        width="50%"
        centered
           className="my-modal"
     
        footer={[]}
      >
    
        <ViewActivity data={data} open={viewOpen} onCancel={() => setViewOpen(false)} />
      </Modal>
         </>
  );
};export default ViewMore;
